// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-cooperation-page {
    background: #ffffff;
}

.project-cooperation-hero {
    position: relative;
    overflow: hidden;
    min-height: 52vh;
    display: flex;
    align-items: center;
    background:
        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),
        #0d0d10;
    color: #ffffff;
}

.project-cooperation-hero-bg {
    position: absolute;
    inset: 0;
}

.project-cooperation-grid {
    position: absolute;
    inset: -24%;
    background-image:
        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);
    background-size: 44px 44px;
    transform: perspective(720px) rotateX(64deg);
    animation: projectCooperationGridMove 24s linear infinite;
}

.project-cooperation-glow {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),
        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);
}

.project-cooperation-hero-content {
    position: relative;
    z-index: 1;
    padding-top: 132px;
    padding-bottom: 72px;
}

.project-cooperation-kicker,
.project-cooperation-page-tag,
.project-cooperation-questionnaire-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.project-cooperation-hero-title {
    margin: 18px 0 14px;
    font-size: clamp(2.5rem, 5vw, 4.5rem);
    line-height: 1.04;
}

.project-cooperation-hero-description {
    max-width: 760px;
    color: rgba(255, 255, 255, 0.84);
    font-size: 1.04rem;
    line-height: 1.8;
}

.project-cooperation-main-section {
    padding-top: 48px;
    padding-bottom: 56px;
}

.project-cooperation-card,
.project-cooperation-questionnaire-panel,
.project-cooperation-status-card {
    border-radius: 24px;
    border: 1px solid rgba(217, 0, 27, 0.08);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #faf7f7 100%);
    box-shadow: 0 18px 40px rgba(22, 22, 26, 0.05);
}

.project-cooperation-card,
.project-cooperation-questionnaire-panel,
.project-cooperation-status-card {
    padding: 28px;
}

.project-cooperation-status-card.is-error {
    border-color: rgba(217, 0, 27, 0.16);
    background: linear-gradient(180deg, #fff9f9 0%, #fff2f4 100%);
}

.project-cooperation-status-card h3 {
    margin-bottom: 8px;
    font-size: 1.24rem;
}

.project-cooperation-status-card p,
.project-cooperation-card p,
.project-cooperation-item-card p,
.project-cooperation-questionnaire-description,
.project-cooperation-questionnaire-copy p,
.project-cooperation-related-description,
.project-cooperation-related-card p,
.project-cooperation-chip small,
.project-cooperation-paragraph-stack p {
    color: var(--text-light);
    line-height: 1.64;
}

.project-cooperation-switcher-panel {
    display: grid;
    gap: 16px;
    margin-bottom: 28px;
    padding: 0 0 30px;
    border-bottom: 1px solid rgba(217, 0, 27, 0.08);
}

.project-cooperation-page .section-header {
    display: grid;
    gap: 8px;
    margin: 0;
}

.project-cooperation-page .section-subtitle {
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.project-cooperation-page .section-title {
    font-size: 1.5rem;
    line-height: 1.2;
}

.project-cooperation-page section.project-cooperation-rich-section {
    padding: 0;
}

.project-cooperation-switcher {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 12px;
}

.project-cooperation-chip {
    min-width: 0;
    padding: 12px 16px;
    border-radius: 14px;
    border: 1px solid rgba(217, 0, 27, 0.1);
    background: transparent;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 10px 12px;
    align-items: start;
    text-align: left;
    transition: transform 0.24s ease, border-color 0.24s ease, box-shadow 0.24s ease;
}

.project-cooperation-chip:hover {
    transform: translateY(-1px);
    border-color: rgba(217, 0, 27, 0.22);
    box-shadow: 0 10px 24px rgba(217, 0, 27, 0.08);
}

.project-cooperation-chip.is-active {
    border-color: rgba(217, 0, 27, 0.32);
    background: rgba(255, 247, 248, 0.75);
}

.project-cooperation-chip span {
    display: inline-flex;
    align-items: center;
    align-self: start;
    width: fit-content;
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(217, 0, 27, 0.06);
    color: var(--accent-red);
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.project-cooperation-chip-copy {
    display: grid;
    gap: 2px;
    min-width: 0;
}

.project-cooperation-chip strong {
    font-size: 1rem;
    line-height: 1.4;
    color: var(--text-main);
}

.project-cooperation-chip small {
    font-size: 0.92rem;
}

.project-cooperation-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 340px;
    gap: 28px;
    align-items: start;
}

.project-cooperation-content {
    min-width: 0;
}

.project-cooperation-card h2 {
    margin: 12px 0 10px;
    font-size: clamp(1.8rem, 3vw, 2.6rem);
    line-height: 1.15;
}

.project-cooperation-meta {
    margin-top: 18px;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4px;
    font-size: 0.86rem;
    line-height: 1.5;
}

.project-cooperation-meta span {
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--text-light);
}

.project-cooperation-meta strong {
    font-size: 0.82rem;
    font-weight: 500;
    color: var(--text-main);
}

.project-cooperation-sections {
    display: grid;
    gap: 26px;
    margin-top: 26px;
    padding-top: 26px;
    border-top: 1px solid rgba(217, 0, 27, 0.08);
}

.project-cooperation-rich-section {
    display: grid;
    gap: 16px;
}

.project-cooperation-rich-section .section-header {
    display: grid;
    gap: 6px;
    margin: 0;
}

.project-cooperation-rich-section .section-title {
    font-size: 1.28rem;
    margin: 0;
}

.project-cooperation-paragraph-stack {
    display: grid;
    gap: 8px;
}

.project-cooperation-item-grid {
    display: grid;
    gap: 0;
    border-top: 1px solid rgba(217, 0, 27, 0.08);
}

.project-cooperation-item-card {
    display: grid;
    grid-template-columns: 92px minmax(0, 1fr);
    gap: 18px;
    align-items: start;
    padding: 18px 0;
    border-bottom: 1px solid rgba(217, 0, 27, 0.08);
}

.project-cooperation-item-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    min-width: 68px;
    padding: 7px 0;
    border-radius: 999px;
    background: rgba(217, 0, 27, 0.06);
    color: var(--accent-red);
    font-size: 0.84rem;
    font-weight: 800;
    letter-spacing: 0.08em;
}

.project-cooperation-item-card h3,
.project-cooperation-questionnaire-panel h3 {
    font-size: 1.06rem;
    line-height: 1.35;
    color: var(--text-main);
}

.project-cooperation-item-copy {
    min-width: 0;
    max-width: 760px;
}

.project-cooperation-item-copy h3 {
    margin: 0 0 6px;
}

.project-cooperation-item-copy p {
    margin: 0;
}

.project-cooperation-questionnaire-panel {
    position: sticky;
    top: 110px;
    display: grid;
    gap: 18px;
}

.project-cooperation-questionnaire-panel h3 {
    font-size: 1.32rem;
}

.project-cooperation-questionnaire-copy {
    display: grid;
    gap: 10px;
    padding-top: 2px;
    border-top: 1px solid rgba(217, 0, 27, 0.08);
}

.project-cooperation-qr-block {
    display: grid;
    grid-template-columns: 132px minmax(0, 1fr);
    gap: 16px;
    align-items: center;
    padding-top: 4px;
}

.project-cooperation-qr-visual {
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    border-radius: 16px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(217, 0, 27, 0.12);
}

.project-cooperation-qr-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
    display: block;
}

.project-cooperation-qr-visual span,
.project-cooperation-qr-copy span {
    color: var(--text-light);
    text-align: center;
    line-height: 1.7;
}

.project-cooperation-qr-copy {
    display: grid;
    gap: 6px;
}

.project-cooperation-qr-copy strong {
    color: var(--text-main);
    font-size: 1rem;
}

@keyframes projectCooperationGridMove {
    from {
        transform: perspective(720px) rotateX(64deg) translateY(0);
    }

    to {
        transform: perspective(720px) rotateX(64deg) translateY(44px);
    }
}

@media (max-width: 1080px) {
    .project-cooperation-layout {
        grid-template-columns: 1fr;
    }

    .project-cooperation-questionnaire-panel {
        position: static;
    }
}

@media (max-width: 768px) {
    .project-cooperation-hero-content {
        padding-top: 118px;
        padding-bottom: 60px;
    }

    .project-cooperation-main-section {
        padding-top: 38px;
        padding-bottom: 40px;
    }

    .project-cooperation-switcher-panel,
    .project-cooperation-card,
    .project-cooperation-questionnaire-panel,
    .project-cooperation-status-card {
        padding: 18px;
        border-radius: 18px;
    }

    .project-cooperation-switcher-panel {
        margin-bottom: 22px;
        padding-bottom: 18px;
    }

    .project-cooperation-switcher {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .project-cooperation-chip {
        padding: 13px 14px;
        border-radius: 14px;
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .project-cooperation-item-card {
        grid-template-columns: 1fr;
        gap: 10px;
        padding: 16px 0;
    }

    .project-cooperation-item-index {
        min-width: 60px;
    }

    .project-cooperation-sections {
        margin-top: 20px;
        padding-top: 20px;
        gap: 18px;
    }

    .project-cooperation-qr-block {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .project-cooperation-qr-visual {
        width: min(220px, 100%);
        margin: 0 auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/project-cooperation.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB;;eAEW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;;+EAE2E;IAC3E,0BAA0B;IAC1B,4CAA4C;IAC5C,yDAAyD;AAC7D;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;sFAEkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;;IAGI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;;IAGI,mBAAmB;IACnB,wCAAwC;IACxC,+EAA+E;IAC/E,8CAA8C;AAClD;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;;;;;;;IASI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,uBAAuB;IACvB,aAAa;IACb,0CAA0C;IAC1C,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gFAAgF;AACpF;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kCAAkC;IAClC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,MAAM;IACN,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,kCAAkC;IAClC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI;QACI,0DAA0D;IAC9D;;IAEA;QACI,6DAA6D;IACjE;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;;;;QAII,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,cAAc;IAClB;AACJ","sourcesContent":[".project-cooperation-page {\r\n    background: #ffffff;\r\n}\r\n\r\n.project-cooperation-hero {\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 52vh;\r\n    display: flex;\r\n    align-items: center;\r\n    background:\r\n        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),\r\n        #0d0d10;\r\n    color: #ffffff;\r\n}\r\n\r\n.project-cooperation-hero-bg {\r\n    position: absolute;\r\n    inset: 0;\r\n}\r\n\r\n.project-cooperation-grid {\r\n    position: absolute;\r\n    inset: -24%;\r\n    background-image:\r\n        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),\r\n        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);\r\n    background-size: 44px 44px;\r\n    transform: perspective(720px) rotateX(64deg);\r\n    animation: projectCooperationGridMove 24s linear infinite;\r\n}\r\n\r\n.project-cooperation-glow {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),\r\n        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);\r\n}\r\n\r\n.project-cooperation-hero-content {\r\n    position: relative;\r\n    z-index: 1;\r\n    padding-top: 132px;\r\n    padding-bottom: 72px;\r\n}\r\n\r\n.project-cooperation-kicker,\r\n.project-cooperation-page-tag,\r\n.project-cooperation-questionnaire-label {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: fit-content;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.project-cooperation-hero-title {\r\n    margin: 18px 0 14px;\r\n    font-size: clamp(2.5rem, 5vw, 4.5rem);\r\n    line-height: 1.04;\r\n}\r\n\r\n.project-cooperation-hero-description {\r\n    max-width: 760px;\r\n    color: rgba(255, 255, 255, 0.84);\r\n    font-size: 1.04rem;\r\n    line-height: 1.8;\r\n}\r\n\r\n.project-cooperation-main-section {\r\n    padding-top: 48px;\r\n    padding-bottom: 56px;\r\n}\r\n\r\n.project-cooperation-card,\n.project-cooperation-questionnaire-panel,\n.project-cooperation-status-card {\n    border-radius: 24px;\n    border: 1px solid rgba(217, 0, 27, 0.08);\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #faf7f7 100%);\n    box-shadow: 0 18px 40px rgba(22, 22, 26, 0.05);\n}\n\n.project-cooperation-card,\n.project-cooperation-questionnaire-panel,\n.project-cooperation-status-card {\n    padding: 28px;\n}\n\r\n.project-cooperation-status-card.is-error {\r\n    border-color: rgba(217, 0, 27, 0.16);\r\n    background: linear-gradient(180deg, #fff9f9 0%, #fff2f4 100%);\r\n}\r\n\r\n.project-cooperation-status-card h3 {\r\n    margin-bottom: 8px;\r\n    font-size: 1.24rem;\r\n}\r\n\r\n.project-cooperation-status-card p,\n.project-cooperation-card p,\n.project-cooperation-item-card p,\n.project-cooperation-questionnaire-description,\n.project-cooperation-questionnaire-copy p,\n.project-cooperation-related-description,\n.project-cooperation-related-card p,\n.project-cooperation-chip small,\n.project-cooperation-paragraph-stack p {\n    color: var(--text-light);\n    line-height: 1.64;\n}\n\r\n.project-cooperation-switcher-panel {\n    display: grid;\n    gap: 16px;\n    margin-bottom: 28px;\n    padding: 0 0 30px;\n    border-bottom: 1px solid rgba(217, 0, 27, 0.08);\n}\n\n.project-cooperation-page .section-header {\n    display: grid;\n    gap: 8px;\n    margin: 0;\n}\n\n.project-cooperation-page .section-subtitle {\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: var(--accent-red);\n}\n\n.project-cooperation-page .section-title {\n    font-size: 1.5rem;\n    line-height: 1.2;\n}\n\n.project-cooperation-page section.project-cooperation-rich-section {\n    padding: 0;\n}\n\n.project-cooperation-switcher {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px 12px;\n}\n\n.project-cooperation-chip {\n    min-width: 0;\n    padding: 12px 16px;\n    border-radius: 14px;\n    border: 1px solid rgba(217, 0, 27, 0.1);\n    background: transparent;\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr);\n    gap: 10px 12px;\n    align-items: start;\n    text-align: left;\n    transition: transform 0.24s ease, border-color 0.24s ease, box-shadow 0.24s ease;\n}\n\n.project-cooperation-chip:hover {\n    transform: translateY(-1px);\n    border-color: rgba(217, 0, 27, 0.22);\n    box-shadow: 0 10px 24px rgba(217, 0, 27, 0.08);\n}\n\n.project-cooperation-chip.is-active {\n    border-color: rgba(217, 0, 27, 0.32);\n    background: rgba(255, 247, 248, 0.75);\n}\n\n.project-cooperation-chip span {\n    display: inline-flex;\n    align-items: center;\n    align-self: start;\n    width: fit-content;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: rgba(217, 0, 27, 0.06);\n    color: var(--accent-red);\n    font-size: 0.76rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.project-cooperation-chip-copy {\n    display: grid;\n    gap: 2px;\n    min-width: 0;\n}\n\n.project-cooperation-chip strong {\n    font-size: 1rem;\n    line-height: 1.4;\n    color: var(--text-main);\n}\n\n.project-cooperation-chip small {\n    font-size: 0.92rem;\n}\n\r\n.project-cooperation-layout {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 340px;\n    gap: 28px;\n    align-items: start;\n}\n\r\n.project-cooperation-content {\r\n    min-width: 0;\r\n}\r\n\r\n.project-cooperation-card h2 {\r\n    margin: 12px 0 10px;\r\n    font-size: clamp(1.8rem, 3vw, 2.6rem);\r\n    line-height: 1.15;\r\n}\r\n\r\n.project-cooperation-meta {\n    margin-top: 18px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 4px;\n    font-size: 0.86rem;\n    line-height: 1.5;\n}\n\n.project-cooperation-meta span {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: var(--text-light);\n}\n\n.project-cooperation-meta strong {\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: var(--text-main);\n}\n\r\n.project-cooperation-sections {\n    display: grid;\n    gap: 26px;\n    margin-top: 26px;\n    padding-top: 26px;\n    border-top: 1px solid rgba(217, 0, 27, 0.08);\n}\n\r\n.project-cooperation-rich-section {\n    display: grid;\n    gap: 16px;\n}\n\r\n.project-cooperation-rich-section .section-header {\n    display: grid;\n    gap: 6px;\n    margin: 0;\n}\n\r\n.project-cooperation-rich-section .section-title {\r\n    font-size: 1.28rem;\r\n    margin: 0;\r\n}\r\n\r\n.project-cooperation-paragraph-stack {\n    display: grid;\n    gap: 8px;\n}\n\n.project-cooperation-item-grid {\n    display: grid;\n    gap: 0;\n    border-top: 1px solid rgba(217, 0, 27, 0.08);\n}\n\n.project-cooperation-item-card {\n    display: grid;\n    grid-template-columns: 92px minmax(0, 1fr);\n    gap: 18px;\n    align-items: start;\n    padding: 18px 0;\n    border-bottom: 1px solid rgba(217, 0, 27, 0.08);\n}\n\n.project-cooperation-item-index {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n    min-width: 68px;\n    padding: 7px 0;\n    border-radius: 999px;\n    background: rgba(217, 0, 27, 0.06);\n    color: var(--accent-red);\n    font-size: 0.84rem;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n}\n\n.project-cooperation-item-card h3,\n.project-cooperation-questionnaire-panel h3 {\n    font-size: 1.06rem;\n    line-height: 1.35;\n    color: var(--text-main);\n}\n\n.project-cooperation-item-copy {\n    min-width: 0;\n    max-width: 760px;\n}\n\n.project-cooperation-item-copy h3 {\n    margin: 0 0 6px;\n}\n\n.project-cooperation-item-copy p {\n    margin: 0;\n}\n\n.project-cooperation-questionnaire-panel {\n    position: sticky;\n    top: 110px;\n    display: grid;\n    gap: 18px;\n}\n\n.project-cooperation-questionnaire-panel h3 {\n    font-size: 1.32rem;\n}\n\n.project-cooperation-questionnaire-copy {\n    display: grid;\n    gap: 10px;\n    padding-top: 2px;\n    border-top: 1px solid rgba(217, 0, 27, 0.08);\n}\n\r\n.project-cooperation-qr-block {\n    display: grid;\n    grid-template-columns: 132px minmax(0, 1fr);\n    gap: 16px;\n    align-items: center;\n    padding-top: 4px;\n}\n\n.project-cooperation-qr-visual {\n    aspect-ratio: 1 / 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px;\n    border-radius: 16px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.92);\n    border: 1px solid rgba(217, 0, 27, 0.12);\n}\r\n\r\n.project-cooperation-qr-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n    border-radius: 12px;\r\n    display: block;\r\n}\r\n\r\n.project-cooperation-qr-visual span,\r\n.project-cooperation-qr-copy span {\r\n    color: var(--text-light);\r\n    text-align: center;\r\n    line-height: 1.7;\r\n}\r\n\r\n.project-cooperation-qr-copy {\r\n    display: grid;\r\n    gap: 6px;\r\n}\r\n\r\n.project-cooperation-qr-copy strong {\n    color: var(--text-main);\n    font-size: 1rem;\n}\n\r\n@keyframes projectCooperationGridMove {\r\n    from {\r\n        transform: perspective(720px) rotateX(64deg) translateY(0);\r\n    }\r\n\r\n    to {\r\n        transform: perspective(720px) rotateX(64deg) translateY(44px);\r\n    }\r\n}\r\n\r\n@media (max-width: 1080px) {\r\n    .project-cooperation-layout {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .project-cooperation-questionnaire-panel {\r\n        position: static;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .project-cooperation-hero-content {\r\n        padding-top: 118px;\r\n        padding-bottom: 60px;\r\n    }\r\n\r\n    .project-cooperation-main-section {\r\n        padding-top: 38px;\r\n        padding-bottom: 40px;\r\n    }\r\n\r\n    .project-cooperation-switcher-panel,\n    .project-cooperation-card,\n    .project-cooperation-questionnaire-panel,\n    .project-cooperation-status-card {\n        padding: 18px;\n        border-radius: 18px;\n    }\n\n    .project-cooperation-switcher-panel {\n        margin-bottom: 22px;\n        padding-bottom: 18px;\n    }\n\n    .project-cooperation-switcher {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n\n    .project-cooperation-chip {\n        padding: 13px 14px;\n        border-radius: 14px;\n        grid-template-columns: 1fr;\n        gap: 8px;\n    }\n\n    .project-cooperation-item-card {\n        grid-template-columns: 1fr;\n        gap: 10px;\n        padding: 16px 0;\n    }\n\n    .project-cooperation-item-index {\n        min-width: 60px;\n    }\n\n    .project-cooperation-sections {\n        margin-top: 20px;\n        padding-top: 20px;\n        gap: 18px;\n    }\n\n    .project-cooperation-qr-block {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n\n    .project-cooperation-qr-visual {\n        width: min(220px, 100%);\n        margin: 0 auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
